import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import IconSvg from '../common/IconSvg';

const PastDot = styled.div`
  width: 14px;
  height: 14px;
  background-color: #08ac08;
  border-radius: 50%;
  margin-right: 28px;
`;

const FutureDot = styled.div`
  width: 14px;
  height: 14px;
  background-color: #cdd3e0;
  border-radius: 50%;
  margin-right: 28px;
`;

const CurrentDot = (
  <IconSvg
    size={44}
    type="onboarding-min"
    css={css`
      transform: rotate(90deg);
      margin-right: 14px;
      margin-left: -14px;
    `}
  />
);

const Progress = props => {
  const { current } = props;
  const pageStepArray = [];

  // add past, current and future dots to the progress bar
  for (let i = 0; i < 3; i++) {
    if (i < current) {
      pageStepArray.push(
        <li key={i}>
          <PastDot />
        </li>,
      );
    } else if (i > current) {
      pageStepArray.push(
        <li key={i}>
          <FutureDot />
        </li>,
      );
    } else {
      pageStepArray.push(<li key={i}>{CurrentDot}</li>);
    }
  }

  return (
    <div>
      <ul
        css={css`
          list-style-type: none;
          padding: 0 28px;
          margin-bottom: 0;
          display: flex;
          align-items: center;
        `}
      >
        {pageStepArray}
      </ul>
    </div>
  );
};

Progress.propTypes = {
  current: PropTypes.number,
};

export default Progress;
